import { render, staticRenderFns } from "./VideodeurbelveiligBedankt.vue?vue&type=template&id=6f08cb00"
import script from "./VideodeurbelveiligBedankt.vue?vue&type=script&lang=js"
export * from "./VideodeurbelveiligBedankt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports